import { Component } from '@angular/core';

@Component({
    selector: 'tun-grabber-icon-v5',
    templateUrl: './grabber-icon-v5.component.html',
    styleUrls: ['./grabber-icon-v5.component.scss'],
    standalone: false
})
export class GrabberIconV5Component {

}
